import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteServiceLevelModalProps {
    level: { id: string; name: string } | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteServiceLevelModal = ({
    level,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteServiceLevelModalProps) => {
    const visible = Boolean(level?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, level?.id]);

    const levelName = level?.name?.trim() || 'this service level';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Remove this service level?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Removing...' : 'Remove level'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to remove <strong>“{levelName}”</strong> from this configuration. This cannot be undone.
            </p>
            <p>Consumables and procedures stay in Resources. Only this column is removed from the matrix.</p>
        </CustomModal>
    );
};
